import React from "react";

import {
  Box,
  BoxProps,
  ContentPlaceHolder,
  ContentPlaceHolderPresetListItem,
} from "@catchoftheday/cg-components";

type ListItemPlaceHolderProps = {
  numberOfItems: number;
} & BoxProps;

export const ListItemPlaceHolder: React.FC<ListItemPlaceHolderProps> = ({
  numberOfItems = 3,
  ...boxProps
}) => (
  <>
    <ContentPlaceHolder width="368" height="13" viewBox="0 0 400 13">
      <rect x="0" y="0" rx="5" ry="5" width="90" height="13" />
    </ContentPlaceHolder>
    {Array(numberOfItems)
      .fill(0)
      .map((_, idx) => (
        <Box key={idx} width="100%" {...boxProps}>
          <ContentPlaceHolderPresetListItem width="368" />
        </Box>
      ))}
  </>
);

export default ListItemPlaceHolder;
